// extracted by css-extract-rspack-plugin
export default {"searchIconWrapper":"_4f0b69dd"};